import Vue from "vue";
import VueRouter from "vue-router";


Vue.use(VueRouter);


const routes = [
    {   
        path: '/', 
        meta: {
            title: ''
        }, 
        redirect: '/index' 
    },
    {   
        path: '/index', 
        name: 'index', 
        meta: {
            title: '首页',
            id: 1
        }, 
        component:() => import('@/views/index/index.vue') 
    },
    { 
        path: '/exam', 
        name: 'exam', 
        meta: {
            title: '考试页面',
            id: 2
        }, 
        component:() => import('@/views/exam/index.vue') 
    },
    { 
        path: '/result', 
        name: 'result', 
        meta: {
            title: '结果页面',
            id: 3
        }, 
        component:() => import('@/views/result/index.vue') 
    },
    { 
        path: '/sign', 
        name: 'sign', 
        meta: {
            title: '报名页面',
            id: 4
        }, 
        component:() => import('@/views/sign/index.vue') 
    }
]
  
const router =  new VueRouter({
    routes
})
export default router;


const blackList = ['exam']


router.beforeEach((to, from, next) => {

    // 确定用户是否已登录  
    let hasToken = false  // 这里就是路由是否通过标准，一般都是通过token来验证
    if(localStorage.getItem('userId')) {
        hasToken = true
    }

    if (hasToken) { 
      if (to.path === '/') {  
        next({ path: '/index' })
        return
      } 
      next()
    } else {
      if (!(blackList.indexOf(to.name) !== -1)) {
        // 在黑名单中的页面
        next()
      } else {
        // 没有访问权限的其他页将重定向到登录页。
        next(`/index`)
      }
    }
  
})